import React from 'react';

import ContentButton from "../content/content-button"

import {
  Dropdown,
} from 'semantic-ui-react';

export default function NavItemSocialIcons(props) {
  //console.log('NavItemSocialIcons - props', props);

  const { pageArea, index, navItem } = props;

  //const textColor = props.textColor ? props.textColor : props.header_text_color ? props.header_text_color : null;
  
  return (
    <>
      {/* <style dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize([
          '#layout-wrapper a.ui.button.postUpSignUpButton {',
          '  color: '+ textColor +';',
          '  box-shadow: inset 0 0 0 2px '+ textColor +' !important;',
          '}',
          '#layout-wrapper a.ui.button.postUpSignUpButton:hover {',
          '  color: '+ props.header_background_color +' !important;',
          '  background: '+ textColor +' !important;',
          '}'
          ].join('\n'))
        }}>
      </style> */}
      {(() => {
        switch(pageArea) {
          case 'mobile-sidebar-nav':
            return (
              <div className={'item social-icon-wrapper'}>
                {navItem.bag && navItem.bag.contentItems.length !== 0 ?
                  navItem.bag.contentItems.map((socialItem, i) => {
                    return (
                      <ContentButton key={i} {...socialItem} />
                    )
                  })
                :
                  null
                }
              </div>
            );
          case 'main-nav-container':
            return (
              null
            );
          case 'main-nav-container-dropdown-item':
            return (
              <Dropdown.Item key={index}>
                <div className={'social-icon-wrapper'}>
                  {navItem.bag && navItem.bag.contentItems.length !== 0 ?
                    navItem.bag.contentItems.map((socialItem, i) => {
                      return (
                        <ContentButton key={i} {...socialItem} />
                      )
                    })
                  :
                    null
                  }
                </div>
              </Dropdown.Item>
            );
          default:
            return null;
        }
      })()}
    </>
  )
}
